module.exports = __webpack_public_path__ + "img/instructions-b.svg";